import VInputYouZanNumber from './index.vue';

export default {
  install: (Vue) => Vue.component('VInputYouZanNumber', VInputYouZanNumber),
};
